import {Component, HostListener, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';

import {FuseConfigService} from '@fuse/services/config.service';
import {FuseSidebarService} from '@fuse/components/sidebar/sidebar.service';

import {UserService} from '../../../services/user.service';
import {UserRepresentation} from '../../../models/UserRepresentation';
import {ConfigService} from '../../../services/config.service';
import {Router} from '@angular/router';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {

    navigation: any;
    fullscreen: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    fullScreenIcon: string;
    fullScreenTooltip: string;
    horizontalNavbar: boolean;
    loggedUser: UserRepresentation;

    private _unsubscribeAll: Subject<any>;

    constructor(
        private _router: Router,
        private _userService: UserService,
        private _configService: ConfigService,
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService
    ) {
        this.fullScreenIcon = 'fullscreen';
        this.fullScreenTooltip = 'Expandir tela';

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    logout(): void {
        this._userService.logout().then();
    }

    toggleFullScreenMode(): void {
        this.fullscreen ? this.exitFullScreen() : this.requestFullScreen();
    }

    toggleSidebarOpen(key): void {
        if (key === 'quickPanel') {
        }
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    openNewTab(): void {
        window.open(window.location.href, '_blank');
    }

    ngOnInit(): void {
        this.getLoggedUserAttributes();
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    private getLoggedUserAttributes(): void {
        this._userService.getLoggedUser().then(u => {
            this.loggedUser = u;
        });
    }

    private requestFullScreen(): void {
        const elem = document.documentElement;
        const methodToBeInvoked = elem.requestFullscreen || elem['webkitRequestFullScreen'] ||
            elem['mozRequestFullscreen'] || elem['msRequestFullscreen'];
        if (methodToBeInvoked) {
            methodToBeInvoked.call(elem);
        }
    }

    private exitFullScreen(): void {
        const doc = document;
        const methodToBeInvoked = doc.exitFullscreen || doc['mozCancelFullScreen'] ||
            doc['webkitExitFullscreen'] || doc['msExitFullscreen'];
        if (methodToBeInvoked) {
            methodToBeInvoked.call(doc);
        }
    }

    @HostListener('document:fullscreenchange')
    private onFullScreenToggle(): void {
        if (this.fullscreen) {
            this.fullScreenIcon = 'fullscreen';
            this.fullScreenTooltip = 'Expandir tela';
        } else {
            this.fullScreenIcon = 'fullscreen_exit';
            this.fullScreenTooltip = 'Diminuir tela';
        }
        this.fullscreen = !this.fullscreen;
    }
}